exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".register-form {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem;\n  background-color: white;\n  padding: 1rem; }\n  @media screen and (max-width: 768px) {\n    .register-form {\n      display: block; }\n      .register-form > * {\n        margin-bottom: 0.5rem; } }\n  .register-form .submit-button {\n    grid-column: 2 span;\n    background-color: #fff;\n    height: 3.2rem;\n    font-size: 1.1rem;\n    letter-spacing: 0.5px;\n    font-weight: bold;\n    border: 0.2rem solid var(--color7, #3e4c5d);\n    color: var(--color7, #3e4c5d); }\n  .register-form .submit-button[disabled] {\n      cursor: not-allowed; }\n  @media screen and (max-width: 768px) {\n      .register-form .submit-button {\n        width: 100%; } }\n  .register-form input {\n    border: 1px solid #cbcfd2; }\n  .register-form input.invalid {\n      border-bottom-color: #ec615f; }\n  .register-form .datepicker-wrapper {\n    position: relative; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/app/components/register-form/register-form.component.scss
// module id = ../../../../../src/app/components/register-form/register-form.component.scss
// module chunks = main